import IDomainMonitorsExportRequest from 'features/domain/model/DomainMonitor/IDomainMonitorsExportRequest';
import {dateRangeToDateAfterBefore, stringToBoolean} from 'shared/lib/filterHelper';

import type {
    IDomainMonitorFiltersForm,
} from '../DomainMonitorsFilters/DomainMonitorFiltersForm/DomainMonitorFiltersForm';

export function buildDomainMonitorsExportRequest({
    domain,
    tags,
    active,
    sslRedirect,
    rknBlock,
    sslActiveTo,
    domainActiveTo,
    orderBy,
}: IDomainMonitorFiltersForm): IDomainMonitorsExportRequest {
    const data: IDomainMonitorsExportRequest = {};

    if (domain) {
        data.domain = domain;
    }

    if (tags && tags.length > 0) {
        data.tags = tags;
    }

    if (active !== null && active !== undefined) {
        data.active = stringToBoolean(active);
    }

    if (sslRedirect !== null && sslRedirect !== undefined) {
        data.ssl_redirect = stringToBoolean(sslRedirect);
    }

    if (rknBlock !== null && rknBlock !== undefined) {
        data.rkn_block = stringToBoolean(rknBlock);
    }

    const sslActiveToRange = dateRangeToDateAfterBefore(sslActiveTo);
    if (sslActiveToRange) {
        data.ssl_active_to = sslActiveToRange;
    }

    const domainActiveToRange = dateRangeToDateAfterBefore(domainActiveTo);
    if (domainActiveToRange) {
        data.domain_active_to = domainActiveToRange;
    }

    if (orderBy?.field) {
        data.order_by = orderBy;
    }

    return data;
}
